import { render } from "./DualSection.vue?vue&type=template&id=7e7f84eb"
import script from "./DualSection.vue?vue&type=script&lang=js"
export * from "./DualSection.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/jwbpinellas/wp-content/themes/jwb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__